






















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import { appName, commonPrefix } from '@/env';
import { readLoginError } from '@/store/main/getters';
import { dispatchSignUp, dispatchLogIn } from '@/store/main/actions';

@Component
export default class Login extends Vue {
  public step: number = 1;
  public username: string = '';
  public email: string = '';
  public password: string = '';
  public appName = appName;
  public newusername: string = '';
  public newemail: string = '';
  public newpassword: string = '';
  public newpasswordRepeat: string = '';
  
  public commonPrefix: string = commonPrefix;
  public audios: HTMLAudioElement[] = [];

  public created() {
    this.createAudios();
  }
  
  public createAudios() {
    const getPostfix = () => {
      const audio = document.createElement('audio');
      const canPlayOgg = audio.canPlayType('audio/ogg') !== '';
      const isSafari = navigator.userAgent.indexOf('Safari') >= 0;
      audio.remove();
      if (canPlayOgg) {
        return 'ogm';
      }
      return 'mp3';
    };

    const postfix = getPostfix();
    for (let i = 1; i<=3; i++) {
      const a = new Audio();
      a.src = `${this.commonPrefix}audios/w${i}.${postfix}`;
      a.preload = 'auto';
     this.audios.push(a);
    }
  }

  public playPianoKey(index: number) {
    const a = this.audios[index];
    // const newA: HTMLAudioElement = a.cloneNode() as HTMLAudioElement;
    // newA.play();
    a.load();
    a.play();
  }

  public get loginError() {
    return readLoginError(this.$store);
  }

  public async submit() {
    this.playPianoKey(2);
    if (await this.$validator.validate('login.*')) {
      dispatchLogIn(this.$store, {username: this.email, password: this.password});
    }
  }

  public resetSignUp() {
    this.newusername = '';
    this.newemail = '';
    this.newpassword = '';
    this.newpasswordRepeat = '';
    this.$validator.reset();
  }

  public async signUp() {
    if (await this.$validator.validate('sign.*')) {
      dispatchSignUp(this.$store, { username: this.newusername, email: this.newemail, password: this.newpassword });
    }
  }
}
